
import React from "react";
import { Button } from "@/components/ui/button";
import { Globe, Apple } from "lucide-react";

interface SocialLoginButtonsProps {
  isSubmitting: boolean;
}

export const SocialLoginButtons = ({ isSubmitting }: SocialLoginButtonsProps) => {
  return (
    <div className="space-y-4">
      <Button 
        type="button" 
        className="w-full bg-[#333333] hover:bg-[#444444] text-white h-14 rounded-md"
        disabled={isSubmitting}
      >
        <Globe className="mr-2 h-5 w-5" />
        Mit Google fortfahren
      </Button>
      
      <Button 
        type="button" 
        className="w-full bg-[#333333] hover:bg-[#444444] text-white h-14 rounded-md"
        disabled={isSubmitting}
      >
        <Apple className="mr-2 h-5 w-5" />
        Mit Apple fortfahren
      </Button>
    </div>
  );
};
